import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const KRStyrvardeMeny: IRutinInfo[] = [
  rutinInfos.rtnKundkategori,
  rutinInfos.optMallKund,
  rutinInfos.rtnFakturaformedlare,
  rutinInfos.rtnBetalningssatt,
  rutinInfos.rtnInbetalningsvag,
  rutinInfos.rtnBetalningsvillkor,
  rutinInfos.rtnAutogiromall,
  rutinInfos.rtnKravrutin,
  rutinInfos.rtnRanteTabell,
  rutinInfos.rtnBank,
];

export default KRStyrvardeMeny;
